import React, { useEffect, useState } from "react";
import { Modal } from "@material-ui/core";
import swal from "sweetalert";
import { API } from "aws-amplify";
import config from "../../config/aws-exports";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import EditIcon from "@material-ui/icons/Edit";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import ReplyIcon from "@material-ui/icons/Reply";
import styles from "./ViewConcernsReason.module.scss";
import { Constants } from "../../config/constants";
import CircularProgress from "@material-ui/core/CircularProgress";
const ViewConcernsReason = ({
  open,
  handleClose,
  reason,
  studentName,
  eid,
  tid,
  bpid,
  oid,
  adminReplies: existingReplies = [],
}) => {
  const [txtQuestion, setTxtQuestion] = useState("");
  const [adminReplies, setAdminReplies] = useState([]);
  const [studentConcern, setStudentConcern] = useState(reason || "");

  const [activeReplyIndex, setActiveReplyIndex] = useState(null);
  const [activeEditIndex, setActiveEditIndex] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setAdminReplies(existingReplies || []);
    setTxtQuestion("");
    setActiveReplyIndex(null);
    setActiveEditIndex(null);
  }, [existingReplies, eid]);

  useEffect(() => {
    console.log("Reason from parent:", reason);
    setStudentConcern(reason || "");
  }, [reason]);

  useEffect(() => {
    if (open) {
      setTxtQuestion("");
      setActiveReplyIndex(null);
      setActiveEditIndex(null);
    }
  }, [open, eid]);

  if (!open) return null;

  const handleReplyClick = (index) => {
    setActiveReplyIndex(index);
    setActiveEditIndex(null);
    setTxtQuestion("");
  };

  const handleEditClick = (index, text) => {
    setActiveEditIndex(index);
    setActiveReplyIndex(null);
    setTxtQuestion(text);
  };

  const closeTextBox = () => {
    setTxtQuestion("");
    setActiveReplyIndex(null);
    setActiveEditIndex(null);
  };

  const handleSubmitQuestion = async () => {
    if (!txtQuestion.trim()) {
      swal("Warning", "Text cannot be empty", "warning");
      return;
    }

    setLoading(true);

    try {
      // Student Edit
      if (activeEditIndex === "student") {
        setStudentConcern(txtQuestion);

        swal("Success", "Concern updated successfully", "success");
      }

      // Admin Reply Edit
      else if (activeEditIndex !== null && activeEditIndex !== "student") {
        const bodyParam = {
          oid,
          bpid,
          topicids: tid,
          eid,
          action: "EDIT_REPLY",
          replyIndex: activeEditIndex,
          adminReply: txtQuestion,
        };

        await API.post(config.aws_cloud_logic_custom_name, "/updateIaMarks", {
          body: bodyParam,
        });

        const updatedReplies = [...adminReplies];

        updatedReplies[activeEditIndex] = {
          ...updatedReplies[activeEditIndex],
          message: txtQuestion,
        };

        setAdminReplies(updatedReplies);

        swal("Success", "Reply updated successfully", "success");
      }

      // Student Reply
      else {
        const bodyParam = {
          oid,
          bpid,
          topicids: tid,
          eid,
          adminReply: txtQuestion,
        };

        await API.post(config.aws_cloud_logic_custom_name, "/updateIaMarks", {
          body: bodyParam,
        });

        setAdminReplies((prev) => [
          ...prev,
          {
            message: txtQuestion,
            createdTime: new Date().toISOString(),
          },
        ]);

        swal("Success", "Reply posted successfully", "success");
      }

      closeTextBox();
    } catch (error) {
      console.error(error);

      swal("Error", "Failed to process request", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteReply = async (index) => {
    const willDelete = await swal({
      title: "Delete Reply?",
      text: "Are you sure you want to delete this reply?",
      icon: "warning",
    });
    if (!willDelete) return;

    //if (!confirmDelete) return;
    setLoading(true);

    try {
      const bodyParam = {
        oid,
        bpid,
        topicids: tid,
        eid,
        action: "DELETE_REPLY",
        replyIndex: index,
      };

      await API.post(config.aws_cloud_logic_custom_name, "/updateIaMarks", {
        body: bodyParam,
      });

      const updatedReplies = [...adminReplies];
      updatedReplies.splice(index, 1);

      setAdminReplies(updatedReplies);

      swal("Success", "Reply deleted successfully", "success");
    } catch (error) {
      console.error(error);

      swal("Error", "Failed to delete reply", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div className={styles.modalContainer}>
        {loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: "rgba(255,255,255,0.6)",
              zIndex: 9999,
            }}
          >
            <CircularProgress style={{ color: Constants.main_color_1 }} />
          </div>
        )}
        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.title}>Concern Discussion</h2>

          <button
            type="button"
            className={styles.closeButton}
            onClick={handleClose}
          >
            ×
          </button>
        </div>

        {/* Student Concern */}
        <div
          style={{
            paddingBottom: "20px",
            borderBottom: "1px solid #ececec",
          }}
        >
          <div className={styles.replyContainer}>
            <div
              style={{
                display: "flex",
                gap: "15px",
                flex: 1,
              }}
            >
              <AccountCircleIcon className={styles.accountIcon} />

              <div style={{ flex: 1 }}>
                <div className={styles.adminName}>{studentName}</div>

                <div className={styles.replyMessage}>
                  {studentConcern || "No concern available"}
                </div>

                {activeReplyIndex === "student" && (
                  <div className={styles.textAreaWrapper}>
                    <textarea
                      value={txtQuestion}
                      onChange={(e) => setTxtQuestion(e.target.value)}
                      rows={4}
                      maxLength={150}
                      placeholder="Reply..."
                      className={styles.textArea}
                    />

                    <div className={styles.buttonContainer}>
                      <button
                        onClick={closeTextBox}
                        className={styles.cancelButton}
                      >
                        Cancel
                      </button>

                      <button
                        onClick={handleSubmitQuestion}
                        className={styles.updateButton}
                      >
                        Send
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className={styles.studentActions}>
              <ReplyIcon
                onClick={() => {
                  if (adminReplies.length < 2) {
                    handleReplyClick("student");
                  }
                }}
                className={styles.replyIcon}
                style={{
                  cursor: adminReplies.length >= 2 ? "not-allowed" : "pointer",
                  color: adminReplies.length >= 2 ? "#ccc" : "#ff6a00",
                  opacity: adminReplies.length >= 2 ? 0.5 : 1,
                }}
              />

              {/* <EditIcon
                onClick={() => handleEditClick("student", studentConcern)}
                style={{
                  cursor: "pointer",
                  fontSize: 28,
                  color: "#222",
                }}
              /> */}
            </div>
          </div>
        </div>

        {/* Replies */}
        {adminReplies.map((reply, index) => (
          <div
            key={`${eid}-${index}-${reply.createdTime || ""}`}
            className={styles.replySection}
          >
            <div className={styles.replyContainer}>
              <div className={styles.adminContent}>
                <AccountCircleIcon className={styles.accountIcon} />

                <div className={styles.adminInfo}>
                  <div className={styles.adminName}>Admin</div>

                  <div className={styles.replyMessage}>{reply.message}</div>
                  {activeEditIndex === index && (
                    <div className={styles.textAreaWrapper}>
                      <textarea
                        value={txtQuestion}
                        onChange={(e) => setTxtQuestion(e.target.value)}
                        maxLength={150}
                        rows={4}
                        placeholder="Edit reply..."
                        className={styles.textArea}
                      />

                      <div className={styles.buttonContainer}>
                        <button
                          onClick={closeTextBox}
                          className={styles.cancelButton}
                        >
                          Cancel
                        </button>

                        <button
                          onClick={handleSubmitQuestion}
                          className={styles.updateButton}
                        >
                          Update
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Student Replies */}
                  {reply?.studentReplies?.map((studentReply, idx) => (
                    <div
                      key={idx}
                      style={{
                        marginTop: "20px",
                        paddingTop: "15px",
                        borderTop: "1px solid #f0f0f0",
                        display: "flex",
                        alignItems: "flex-start",
                        transform: "translateX(-57px)",
                      }}
                    >
                      <AccountCircleIcon className={styles.accountIcon} />
                      <div style={{ marginLeft: "10px", flex: 1 }}>
                        <div className={styles.adminName}>{studentName}</div>

                        <div className={styles.replyMessage}>
                          {studentReply.message}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className={styles.actionContainer}>
                {/* <ReplyIcon
                  onClick={() => handleReplyClick(index)}
                  style={{
                    cursor: "pointer",
                    color: "#ff6a00",
                    fontSize: 28,
                    transform: "scaleX(-1)",
                  }}
                /> */}

                <EditIcon
                  onClick={() => handleEditClick(index, reply.message)}
                  className={styles.actionIcon}
                />

                <DeleteOutlineIcon
                  onClick={() => handleDeleteReply(index)}
                  className={styles.actionIcon}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default ViewConcernsReason;
